// extracted by mini-css-extract-plugin
module.exports = {"loginBlockHeader":"loginBlockHeader-OjiuG","loginBlockHeaderTitle":"loginBlockHeaderTitle-FsnaU"};